{
  "version": 1,
  "asset_id": "f60318d0-99b6-4352-8a41-61ddc81512cb",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f60318d0-99b6-4352-8a41-61ddc81512cb/scar-tissue-crura-esophagus-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f60318d0-99b6-4352-8a41-61ddc81512cb/scar-tissue-crura-esophagus-es-800.webp",
  "original_filename": "scar-tissue-crura-esophagus-es-800.webp",
  "size": 87568,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:56:13Z"
}
